export enum Vendor {
  Way4 = "Way4",
  Atan = "Atan",
  SupplierApi = "SupplierApi",
  Benzuber = "Benzuber",
}

export default Vendor;
